import React from 'react';

const SaveIcon = (props) => {
	return (
		<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			width="20px" height="20px" viewBox="0 0 45 45" enableBackground="new 0 0 45 45" xmlSpace="preserve">
			<g>
				<path fill="#F5F7FA" d="M42.5,19.408H40V1.843c0-0.69-0.561-1.25-1.25-1.25H6.25C5.56,0.593,5,1.153,5,1.843v17.563H2.5
		c-1.381,0-2.5,1.119-2.5,2.5v20c0,1.381,1.119,2.5,2.5,2.5h40c1.381,0,2.5-1.119,2.5-2.5v-20C45,20.525,43.881,19.408,42.5,19.408z
		 M32.531,38.094H12.468v-5h20.063V38.094z M37.5,19.408H35c-1.381,0-2.5,1.119-2.5,2.5v5h-20v-5c0-1.381-1.119-2.5-2.5-2.5H7.5
		V3.093h9.374v10.625h-3.125c-0.505,0-0.961,0.305-1.154,0.771c-0.193,0.467-0.086,1.005,0.271,1.362l8.749,8.75
		c0.488,0.488,1.279,0.488,1.768,0l8.751-8.749c0.357-0.357,0.464-0.895,0.271-1.362c-0.191-0.467-0.647-0.771-1.153-0.771h-3.125
		V3.093h9.376L37.5,19.408L37.5,19.408z"/>
			</g>
		</svg>

	);
};

export default SaveIcon;